import React from "react";
import {AppBar, Box, Divider, Stack, Toolbar, Typography, useMediaQuery, useTheme} from "@mui/material";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import RegisterButton from "./RegisterButton";

const Footer: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <AppBar
            position="static"
            component="footer"
            sx={{
                backgroundColor: "#DEE8FF"
            }}
        >
            <Toolbar>
                <Stack
                    direction={isMobile ? "column" : "row"}
                    alignItems={isMobile ? "center" : "center"}
                    sx={{
                        width: '100%',
                        px: {xs: 2, sm: 4, md: 6},
                        py: {xs: 2, sm: 3, md: 4},
                        spacing: isMobile ? 2 : 0
                    }}
                    spacing={isMobile ? 2 : 0}
                >
                    <Stack
                        direction="column"
                        sx={{
                            flex: isMobile ? 'none' : 1,
                            textAlign: isMobile ? 'center' : 'left'
                        }}
                        spacing={isMobile ? 1 : 0}
                    >
                        <Typography
                            component="div"
                            sx={{
                                fontFamily: 'Kyiv Type Serif',
                                fontWeight: 700,
                                fontSize: {xs: 16, sm: 18, md: 20},
                            }}
                        >
                            Якщо лишаються питання:
                        </Typography>

                        <Typography
                            sx={{
                                fontFamily: 'Kyiv Type Sans',
                                fontWeight: 400,
                                fontSize: {xs: 16, sm: 18, md: 20},
                                mt: 1,
                            }}
                        >
                            Телефон: <a style={{ color: '#000000', fontWeight: '600', textDecoration: 'none' }} href="tel:+380681786106">(068) 178-61-06</a>
                        </Typography>

                        <Typography
                            sx={{
                                fontFamily: 'Kyiv Type Sans',
                                fontWeight: 400,
                                fontSize: {xs: 16, sm: 18, md: 20},
                                mt: 1,
                            }}
                        >
                            E-mail: <a style={{ color: '#000000', fontWeight: '600', textDecoration: 'none' }} href="mailto:abiturient.team@ukma.edu.ua">abiturient.team@ukma.edu.ua</a>
                        </Typography>
                    </Stack>

                    {!isMobile && (
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{
                                backgroundColor: "#000000",
                                mx: 4,
                            }}
                        />
                    )}

                    <Box
                        sx={{
                            flex: isMobile ? 'none' : 1,
                            display: 'flex',
                            justifyContent: isMobile ? 'center' : 'center',
                            alignItems: 'center',
                            mt: isMobile ? 2 : 0,
                        }}
                    >
                        <RegisterButton
                            text={'Зареєструватися'}
                        />
                    </Box>
                </Stack>
            </Toolbar>

            <Typography
                sx={{
                    fontFamily: 'Kyiv Type Sans',
                    fontWeight: 400,
                    fontSize: {xs: 14, sm: 16},
                    color: "#000000",
                    textAlign: 'center',
                    pb: 1
                }}
            >
                Розроблено студентською організацією <a style={{ color: '#000000', fontWeight: '600', textDecoration: 'none' }} href={'https://vstup.ukma.edu.ua/student-organization?so-id=8'}>Вступ НаУКМА</a>
            </Typography>
        </AppBar>
    );
};

export default Footer;